import logo from 'assets/logo.svg'
import {landingLink} from 'features/unauthorized/components/AuthPage/common/core/constants'

const Header = ({title}: {title: string}) => {
    const redirectToLanding = () => {
        window.location.href = landingLink
    }
    return (
        <div className="flex flex-1 items-center justify-center gap-4 pt-5 pb-8 xs:gap-5">
            <img
                className="z-10 w-36 xs:w-40"
                src={logo}
                alt="no coins"
                onClick={redirectToLanding}
            />
            <div className="h-full w-0.5 bg-white" />
            <div className="self-end text-3xl text-white">{title}</div>
        </div>
    )
}
export default Header
